//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import integrationsLogo from "@/assets/images/IntegrationsSquare.svg";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQCard from "./AQCard.vue";

export default {
    name: "IntegrationCard",
    components: {
        AQCard,
        AQButton,
        AQMenu
    },

    props: {
        dbType: { type: String, default: "" },
        hostname: { type: String, default: "" },
        dbName: { type: String, default: "" },
        connectionName: { type: String, default: "" },
        status: { type: String, default: "" }
    },
    data() {
        return {
            resetSelectedData: false,
            headerMenu: [
                {
                    value: "edit",
                    label: this.$t("globalDataModel.editEntity")
                }
            ],
            showMenu: [],
            integrationLogo: integrationsLogo
        };
    },
    methods: {
        selectedOption($event) {
            if ($event[0].value === "edit") {
                this.$emit("openEditIntegration");
                this.resetSelectedData = true;
            }
        }
    }
};
